"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyToClipboardButton = void 0;
var React = require("react");
var Recompose = require("recompose");
var components_1 = require("../../components");
var clipboard_1 = require("../../utils/clipboard");
var enhance = Recompose.compose(Recompose.pure, Recompose.setDisplayName('CopyToClipboardButton'), Recompose.withState('isCopied', 'setIsCopied', false), Recompose.lifecycle({
    componentDidUpdate: function (_) {
        var _this = this;
        if (this.props.isCopied) {
            setTimeout(function () { return _this.props.setIsCopied(false); }, 2000);
        }
    }
}));
exports.CopyToClipboardButton = enhance(function (props) {
    var iconClass = props.isCopied ? 'fa-check-circle' : 'fa-copy';
    var tooltipBody = (React.createElement("span", null, props.isCopied ? props.tooltipContentWhenCopied : props.tooltipContent));
    return (React.createElement(components_1.Tooltip, { tipPosition: 'center', content: tooltipBody },
        React.createElement(components_1.Icon, { className: "sok-copy-to-clipboard-button ".concat(iconClass), onClick: function () {
                (0, clipboard_1.copy)(props.copyableContent);
                props.setIsCopied(true);
            } })));
});
//# sourceMappingURL=index.js.map